export default "__VITE_ASSET__Brlps7jh__"